import TCFConsentMessage from './TCFConsentMessage'

export default TCFConsentMessage
